var map = {
	"./arrow-curve-up-left.svg": 24609,
	"./arrow-left.svg": 46859,
	"./arrow-path.svg": 56805,
	"./arrow-right.svg": 9934,
	"./arrow-up-right.svg": 77742,
	"./arrows-up-down.svg": 96673,
	"./association.svg": 57537,
	"./associations.svg": 71920,
	"./attention-mini.svg": 86686,
	"./attention.svg": 10222,
	"./bars-3.svg": 76890,
	"./build.svg": 55452,
	"./calendar-days.svg": 29822,
	"./calendar-range.svg": 63958,
	"./cards.svg": 55441,
	"./case.svg": 17008,
	"./chart-bar.svg": 68420,
	"./chart-pie.svg": 18741,
	"./check-circle.svg": 47425,
	"./check.svg": 42100,
	"./checklist.svg": 7836,
	"./chevron-down-solid.svg": 95520,
	"./chevron-down.svg": 2434,
	"./chevron-left.svg": 37705,
	"./chevron-right.svg": 75764,
	"./chevron-up-solid.svg": 60535,
	"./chevron-up.svg": 85873,
	"./close.svg": 26112,
	"./cloud.svg": 303,
	"./computer.svg": 69567,
	"./copy.svg": 92411,
	"./deal.svg": 90246,
	"./delete.svg": 36805,
	"./doc-solid.svg": 71676,
	"./document-arrow-down.svg": 1640,
	"./document-arrow-up.svg": 59099,
	"./document-chart-bar.svg": 62896,
	"./document-check.svg": 99256,
	"./document-list.svg": 37416,
	"./document-plus.svg": 37024,
	"./document.svg": 63591,
	"./download-file.svg": 5535,
	"./drag-drop.svg": 28707,
	"./duplicate.svg": 61159,
	"./edit.svg": 25448,
	"./email.svg": 53780,
	"./eye-slash.svg": 21183,
	"./eye.svg": 5747,
	"./flag.svg": 51810,
	"./folder-open.svg": 78017,
	"./heart-off.svg": 83044,
	"./heart-on.svg": 53006,
	"./help.svg": 67501,
	"./home.svg": 56425,
	"./indicator.svg": 44383,
	"./information-circle.svg": 61699,
	"./key.svg": 81129,
	"./link.svg": 35052,
	"./list.svg": 47460,
	"./map-pin.svg": 6940,
	"./max.svg": 71574,
	"./message.svg": 24217,
	"./minus.svg": 88164,
	"./more-vertical.svg": 4542,
	"./more.svg": 27263,
	"./news.svg": 76873,
	"./notification.svg": 4801,
	"./numbered-list.svg": 93185,
	"./organization.svg": 53545,
	"./pencil-square.svg": 10057,
	"./pfdo.svg": 12905,
	"./phone.svg": 50008,
	"./photo.svg": 79216,
	"./play-circle.svg": 38479,
	"./plus-circle.svg": 89081,
	"./plus.svg": 17452,
	"./qr-code.svg": 21353,
	"./question-circle.svg": 73037,
	"./question.svg": 85728,
	"./refund.svg": 88978,
	"./route.svg": 53243,
	"./scale.svg": 66610,
	"./search.svg": 91072,
	"./settings.svg": 4539,
	"./share.svg": 16453,
	"./sort.svg": 41160,
	"./sparkles.svg": 31706,
	"./star.svg": 39108,
	"./stop-circle.svg": 39105,
	"./tag.svg": 48724,
	"./tg.svg": 31591,
	"./time.svg": 18199,
	"./trash.svg": 39666,
	"./tree.svg": 44364,
	"./trophy.svg": 10170,
	"./upload.svg": 70871,
	"./user-group.svg": 64707,
	"./user-minus.svg": 96206,
	"./user-plus.svg": 56934,
	"./user.svg": 44717,
	"./users.svg": 71556,
	"./video-camera.svg": 42375,
	"./vk.svg": 36829,
	"./web.svg": 50230,
	"./x-circle-outlined.svg": 90088,
	"./x-circle.svg": 54041,
	"./yandex.svg": 6359
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80200;